import {Avatar, Button, Image, message} from 'antd'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getAvatar from 'helpers/getAvatar'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import UserContext from '../UserContext'
import {FollowButton} from '../../../../components/Feed/FollowButton'
import {renderIf} from '../../../Shared'
import {PhotoPlaceholderUser} from '../../../../conts/imageBase64'
import {Link} from 'react-router-dom'
import categoryIcons from '../../../../conts/categoryIcons'
import {paths} from '../../../MainPage/contains'
import {RiFacebookFill, RiSignalTowerFill, RiToolsFill, RiTwitterXLine, RiUser2Fill} from 'react-icons/ri'
import {
    PiBriefcaseFill,
    PiCalendarFill,
    PiChats,
    PiGraduationCapFill,
    PiHouseFill, PiLinkBold,
    PiLinkSimpleBold,
    PiMapPinFill,
} from 'react-icons/pi'
import {BiSolidChurch} from 'react-icons/bi'
import {HeaderButton} from '../../../Organization/components/PageHeader'
import copyToClipboard from 'copy-to-clipboard'
import {ROOT_URL} from '../../../../envs/_current/config'
import getLinkToDetail from 'helpers/getLinkToDetail'
import TooltipApp from 'components/TooltipApp'
import {AiOutlineArrowLeft} from 'react-icons/ai'
import {ConversationWith} from '../../factory/createChatButton'
import {getId, getType} from '../../../../apis/model/base'
import getAliasName from '../../../../helpers/getAliasName'
import {usePromoFunc} from '../../../Shared/functions/usePromoFunc'
import {BsCalendarWeek, BsFacebook, BsPatchCheckFill, BsThreeDots, BsTools, BsTwitterX} from 'react-icons/bs'
import {TbHeartCheck, TbHeartX} from 'react-icons/tb'
import DrawMenu from '../../../../components/drawer/DrawMenu'
import {SystemPermission} from '../../../../components/RequiredAdmin'
import {LoginContext} from '../../../../components/LoginContext'
import {formatDate} from '../../../../helpers/datetimeHelpers'
import {useHistory} from 'modules/navigation/useRouter'
import {createFacebookShareLink, createTwitterShareLink} from "../../../../helpers";
import classNames from "classnames";
import {VscArrowLeft} from "react-icons/vsc";
import {formatNumber} from "../../../../helpers/number";
import {FiTool} from "react-icons/fi";
import {ReligiousFillSvg} from "../../../../components/Svgs/ReligiousIconSvg";
import {IoHome} from "react-icons/io5";
import {HiLink} from "react-icons/hi2";

const BannerSkeleton = ({isSm}) => (
    <div className="flex flex-col -mx-2 md:-mx-3">
        <div
            className="w-full background-200"
            style={{height: isSm ? 150 : 180}}
        />
        <div
            className="w-full max-w-6xl mx-auto px-3 md:px-0 flex flex-col gap-3"
            style={{marginTop: isSm ? -30 : -40}}>
            <div className="flex items-end justify-between">
                <div
                    className="rounded-full background-200 border-4 border-color-50 flex-shrink-0"
                    style={{width: isSm ? 76 : 100, height: isSm ? 76 : 100}}
                />
                <div className="h-8 w-24 background-200 rounded-full mb-1"/>
            </div>
            <div className="flex flex-col gap-2">
                <div className="h-5 w-40 background-200 rounded"/>
                <div className="h-3 w-28 background-200 rounded"/>
                <div className="h-3 w-full max-w-md background-200 rounded"/>
            </div>
        </div>
    </div>
)

const UserBanner = React.memo(({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {user} = useContext(UserContext)
    const {isSm, isLg} = useContext(LayoutContext)
    const history = useHistory()

    if (!user) return <BannerSkeleton isSm={isSm}/>

    const {
        name, email, certified, username, religious_order_name, occupation,
        quote, about, country, created,
        total_followers, total_following, total_channels,
        hometown, company, school, categories,
    } = user ?? {}
    const bio = quote || about
    const location = _.get(country, 'common_name')
    const diocese = _.get(user, 'diocese.fullname')
    const shareUrl = `${ROOT_URL}${getLinkToDetail(user)}`

    const {onAddToRecommendation, onRemoveFromRecommendation} = usePromoFunc({})

    const login = useContext(LoginContext)
    const it_me = user?.id === login?.id

    return (
        <div
            className={classNames(
            "flex flex-col relative",
                isLg ? "-mx-3 mt-6 mt-6 mb-3 rounded-xl overflow-hidden" : "-mx-3 -mt-3 mb-4"
            )}>
            <div className="relative">
                <Image
                    preview={false}
                    src={_.get(user, 'cover_photo') || PhotoPlaceholderUser}
                    wrapperClassName="w-full"
                    className="fadeIn animated"
                    style={{height: isSm ? 150 : 180, backgroundSize: 'contain'}}
                />
                {!isLg && (
                    <div
                        onClick={() => history.goBack()}
                        style={{
                            width: 32, height: 32,
                            borderRadius: 999,
                        }}
                        className="absolute top-10 left-10 flex flex-center bg-white opacity-60 cursor-pointer">
                        <VscArrowLeft size={16} className="text-gray-700"/>
                    </div>
                )}
            </div>

            <div
                style={{marginTop: isLg ? -40 : -30}}
                className="w-full max-w-6xl mx-auto px-3 md:px-2 flex flex-col gap-3">
                <div className="flex items-end justify-between gap-3">
                    <div className="relative">
                        <Avatar
                            size={isSm ? 76 : 100}
                            style={{border: '4px solid #fff', flexShrink: 0}}
                            icon={<RiUser2Fill size={isSm ? 38 : 60} className="text-color-500"/>}
                            src={getAvatar(user)}
                            className="flex flex-center background-200"
                        />
                        <div
                            className="shadow absolute"
                            style={{
                                bottom: 6,
                                right: 6,
                                width: 14,
                                height: 14,
                                borderRadius: 999,
                                background: user?.active === 1 ? '#48bb78' : 'var(--text-color-400)',
                                borderWidth: 2,
                                borderColor: user?.active === 1 ? '#fff' : '#e6e6e6',
                            }}
                        />
                    </div>
                    <div className="flex items-center gap-x-2 md:gap-x-3 mb-2">
                        {renderIf(
                            !it_me,
                            <FollowButton item={user} size="medium"/>
                        )}
                        {renderIf(
                            !it_me && user?.follow_status === true,
                            <ConversationWith
                                params={{receiver_id: getId(user)}}
                                render={(__, {onClick}) => (
                                    <HeaderButton
                                        onClick={onClick}
                                        width={28}
                                        height={28}
                                        icon={
                                            <TooltipApp
                                                title={t('send message')}
                                                placement="bottomRight"
                                                overlayClassName="text-xs italic">
                                                <PiChats size={13}/>
                                            </TooltipApp>
                                        }
                                    />
                                )}
                            />
                        )}
                        <SystemPermission system={true}>
                            {(isAdmin) => (
                                <DrawMenu
                                    menu={{
                                        items: [
                                            {
                                                key: 'COPY_LINK',
                                                icon: <PiLinkBold className="text-blue-600"/>,
                                                label: (
                                                    <span className="text-color-100">
                                                        {t('copy link')}
                                                    </span>
                                                ),
                                            },
                                            {
                                                key: 'SHARE_FACEBOOK',
                                                icon: <BsFacebook className="text-blue-800"/>,
                                                label: (
                                                    <span className="text-color-100">
                                                        Facebook
                                                    </span>
                                                ),
                                            },
                                            {
                                                key: 'SHARE_TWITTER',
                                                icon: <BsTwitterX className="text-color-000"/>,
                                                label: (
                                                    <span className="text-color-100">
                                                        X (Twitter)
                                                    </span>
                                                ),
                                            },
                                            ...(isAdmin ? [
                                                {
                                                    key: 'ADD_TO_RECOMMENDATION',
                                                    icon: <TbHeartCheck className="text-primary-600"/>,
                                                    label: (
                                                        <span className="text-color-100">
                                                            {t('add to recommendation')}
                                                        </span>
                                                    ),
                                                },
                                                {
                                                    key: 'REMOVE_FROM_RECOMMENDATION',
                                                    icon: <TbHeartX className="text-primary-600"/>,
                                                    label: (
                                                        <span className="text-color-100">
                                                            {t('remove from recommendation')}
                                                        </span>
                                                    ),
                                                },
                                            ] : []),
                                        ],
                                        onClick: ({key}) => {
                                            switch (key) {
                                                case 'COPY_LINK':
                                                    copyToClipboard(shareUrl)
                                                    message.success(t('copied'))
                                                    break
                                                case 'SHARE_FACEBOOK':
                                                    window.open(createFacebookShareLink(shareUrl), '_blank')
                                                    break
                                                case 'SHARE_TWITTER':
                                                    window.open(createTwitterShareLink(shareUrl), '_blank')
                                                    break
                                                case 'ADD_TO_RECOMMENDATION':
                                                    onAddToRecommendation({
                                                        owner_type: getType(user),
                                                        owner_id: getId(user),
                                                    })
                                                    break
                                                case 'REMOVE_FROM_RECOMMENDATION':
                                                    onRemoveFromRecommendation({
                                                        owner_type: getType(user),
                                                        owner_id: getId(user),
                                                    })
                                                    break
                                                default:
                                                    break
                                            }
                                        },
                                    }}
                                    menuPlacement="bottomLeft"
                                    component={
                                        <Button
                                            color="default" variant="filled"
                                            style={{ width: 28, height: 28 }}
                                            className="flex flex-center text-color-300 px-1 rounded-full">
                                            <BsThreeDots size={14} />
                                        </Button>
                                    }
                                />
                            )}
                        </SystemPermission>
                    </div>
                </div>
                <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-0.5 min-w-0">
                        <span className="font-extrabold text-lg md:text-xl text-color-000 leading-snug uppercase tracking-wide truncate flex items-center gap-1.5">
                            <span className="font-medium text-base text-slate-500 capitalize">
                                {getAliasName(user, 'patron_saint') || ''}
                            </span>
                            {name}
                            {renderIf(
                                certified === 1,
                                <TooltipApp title={t('verified')} classNames={{root: 'font-medium text-xs italic'}}>
                                    <BsPatchCheckFill
                                        size={isSm ? 14 : 17}
                                        className="text-blue-500 zoom-animation cursor-pointer flex-shrink-0"
                                    />
                                </TooltipApp>
                            )}
                        </span>
                        <span className="text-xs text-color-300 tracking-wider">
                            {email ? email : `@${username}`}
                        </span>
                    </div>

                    {renderIf(
                        bio,
                        <div className="text-sm tracking-wide whitespace-pre-line">{bio}</div>
                    )}

                    {renderIf(
                        location || created || diocese || hometown || company || school || occupation || religious_order_name,
                        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-color-400">
                            {renderIf(
                                location,
                                <span className="flex items-center gap-1 font-medium text-gray-700">
                                    <PiMapPinFill size={13}/>
                                    {location}
                                </span>
                            )}
                            {renderIf(
                                diocese,
                                <span className="flex items-center gap-1 font-medium text-gray-700">
                                    <BiSolidChurch size={13}/>
                                    {diocese}
                                </span>
                            )}
                            {renderIf(
                                religious_order_name,
                                <span className="flex items-center gap-1 font-medium text-gray-700">
                                    <ReligiousFillSvg size={13}/>
                                    {religious_order_name}
                                </span>
                            )}
                            {renderIf(
                                company,
                                <span className="flex items-center gap-1 font-medium text-gray-700">
                                    <PiBriefcaseFill size={13}/>
                                    {company}
                                </span>
                            )}
                            {renderIf(
                                occupation,
                                <span className="flex items-center gap-1 font-medium text-gray-700">
                                    <BsTools size={11}/>
                                    {occupation}
                                </span>
                            )}
                            {renderIf(
                                school,
                                <span className="flex items-center gap-1 font-medium text-gray-700">
                                    <PiGraduationCapFill size={13}/>
                                    {school}
                                </span>
                            )}
                            {renderIf(
                                hometown,
                                <span className="flex items-center gap-1 font-medium text-gray-700">
                                    <IoHome size={13}/>
                                    {hometown}
                                </span>
                            )}
                            {renderIf(
                                created,
                                <span className="flex items-center gap-1 font-medium text-gray-700">
                                    <BsCalendarWeek size={11}/>
                                    {t('joined')} {formatDate(created, 'MM/YYYY')}
                                </span>
                            )}
                        </div>
                    )}

                    <div className="flex flex-wrap gap-x-4 gap-y-1">
                        {total_following > 0 && (
                            <span className="text-color-300 whitespace-no-wrap">
                                <span className="mr-1 tabular-nums font-semibold text-color-000">
                                    {formatNumber(Number(total_following))}
                                </span>
                                {t('following')}
                            </span>
                        )}
                        {total_followers > 0 && (
                            <span className="text-color-300 whitespace-no-wrap">
                                <span className="mr-1 tabular-nums font-semibold text-color-000">
                                    {formatNumber(Number(total_followers))}
                                </span>
                                {t('followers')}
                            </span>
                        )}
                        {total_channels > 0 && (
                            <span className="flex items-center text-color-300 whitespace-no-wrap">
                                <RiSignalTowerFill size={12} className="mr-1"/>
                                <span className="mr-1 tabular-nums font-semibold text-color-000">
                                    {formatNumber(Number(total_channels))}
                                </span>
                                {t('channels')}
                            </span>
                        )}
                    </div>

                    {renderIf(
                        categories?.length > 0,
                        <div className="flex flex-wrap gap-2">
                            {(categories ?? []).map((category, index) => {
                                const Icon = _.get(categoryIcons, category?.id, categoryIcons['default'])
                                return (
                                    <Link
                                        key={index}
                                        to={paths.categoryPath.replace(':category', category?.id)}
                                        style={{padding: '5px 10px'}}
                                        className="flex flex-center gap-1.5 border border-blue-300 hover:border-blue-500 bg-blue-50 hover:bg-blue-100 rounded-lg no-underline">
                                        <Icon size={12} className="text-blue-500"/>
                                        <span style={{ fontSize: 12 }} className="font-medium text-blue-600 leading-tight">
                                            {category?.name}
                                        </span>
                                    </Link>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
})

export default UserBanner
